<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-btn flat slot="activator">
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <h2>Crea Corso</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <!-- Nome Corso -->

          <v-layout row wrap>
            <v-flex xs12 sm10>
              <v-text-field v-model="course_name" :rules="nameRules" label="Nome Corso" required></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <!-- Tipo Corso -->

            <v-flex xs12 sm5 mt-3>
              <v-select v-model="tipoCorso" :items="type" :rules="typeRule" label="Tipologia Corso"></v-select>
            </v-flex>

            <!-- Posti Corso -->

            <v-flex xs12 sm5 offset-sm1 mt-3>
              <v-text-field
                type="number"
                v-model="course_places"
                label="Posti Corso"
                required
                :rules="placesRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <!-- Date Inizio Corso -->

            <v-flex xs12 sm5 mt-3>
              <v-menu
                v-model="menu"
                :close-on-content-click="true"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="dateStartRules"
                    v-model="startDate"
                    label="Data Inizio Corso"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDateTemp"
                  locale="it-IT"
                  :min="currentDayTemp"
                  :max="finishDateTemp"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- Date Fine Corso -->

            <v-flex xs12 sm5 offset-sm1 mt-3>
              <v-menu
                v-model="menu2"
                :close-on-content-click="true"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="dateFinishRules"
                    v-model="finishDate"
                    label="Data Fine Corso"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="finishDateTemp" locale="it-IT" :min="startDateTemp"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <!-- Ora Inizio Corso -->

            <v-flex xs12 sm5 mt-3>
              <v-menu
                ref="menu"
                v-model="menu_time_start"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time_start"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="timeStartRule"
                    v-model="time_start"
                    label="Orario Inizio Corso"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu_time_start"
                  format="24hr"
                  v-model="time_start"
                  full-width
                  @click:minute="$refs.menu.save(time_start)"
                ></v-time-picker>
              </v-menu>
            </v-flex>

            <!-- Ora Fine Corso -->

            <v-flex xs12 sm5 offset-sm1 mt-3>
              <v-menu
                ref="menu2"
                v-model="menu_time_finish"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time_finish"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="timeFinishRule"
                    v-model="time_finish"
                    label="Orario Fine Corso"
                    prepend-icon="access_time"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu_time_finish"
                  format="24hr"
                  v-model="time_finish"
                  full-width
                  @click:minute="$refs.menu2.save(time_finish)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- Descrizione Svolgimento Corso -->

          <v-layout row wrap>
            <v-flex xs12 mt-3>
              <v-textarea
                v-model="description"
                :rules="descriptionRules"
                label="Descrizione Svolgimento"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>

          <!-- Note Corso -->

          <v-layout row wrap>
            <v-flex xs12 mt-3>
              <v-textarea v-model="note" :rules="noteRules" label="Note Aggiuntive" required></v-textarea>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm8 md6 mt-5 offset-sm2 offset-md3>
              <v-btn color="success" @click="onCreate()" :loading="loading">Conferma</v-btn>
              <v-btn color="error" @click="closeDialog()">Annulla</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
export default {
  data: () => ({
    changed: false,
    dialog: false,
    valid: true,
    course_name: "",
    course_places: 0,
    menu: "",
    menu2: "",
    menu_time_start: false,
    menu_time_finish: false,
    time_start: null,
    time_finish: null,
    startDate: null,
    finishDate: null,
    finishDateTemp: null,
    startDateTemp: null,
    currentDay: null,
    currentDayTemp: new Date().toISOString().substr(0, 10),
    nameRules: [
      v => !!v || "Nome Corso necessario",
      v =>
        (v && v.length <= 50) ||
        "Il Nome del corso deve essere minore di 50 caratteri"
    ],
    descriptionRules: [
      v => !!v || "Descrizione svolgimento corso necessaria",
      v =>
        (v && v.length <= 200) ||
        "La Descrizione del corso deve essere minore di 200 caratteri"
    ],
    placesRules: [
      v => (v && v > 0) || "Numero posti deve essere maggiore di 0"
    ],
    typeRule: [v => !!v || "Tipologia Corso necessaria"],
    type: [],
    tipoCorso: "",
    note: "",
    description: "",
    loading: false,
    dateStartRules: [v => !!v || "Data inizio corso necessaria"],
    dateFinishRules: [v => !!v || "Data fine corso necessaria"],
    timeStartRule: [v => !!v || "Ora inizio corso necessaria"],
    timeFinishRule: [v => !!v || "Ora fine corso necessaria"]
  }),

  watch: {
    startDate() {
      this.dateValidation();
    },
    finishDate() {
      this.dateValidation();
    },
    startDateTemp() {
      this.startDateFilter();
    },
    finishDateTemp() {
      this.finishDateFilter();
    },
    time_start() {
      this.timeValidation();
    },
    time_finish() {
      this.timeValidation();
    }
  },
  computed: {
    noteRules() {
      const rules = [];
      var rule = "";
      if (this.note) {
        rule = v =>
          v.length <= 200 ||
          "Le note non possono essere più lunghe di 200 caratteri";
        rules.push(rule);
      }
      return rules;
    }
  },

  methods: {
    listener() {
      db.collection("tipi_corso")
        .get()
        .then(querySnapshot => {
          this.type = [];
          querySnapshot.forEach(doc => {
            this.type.push(doc.data().nome);
          });
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel caricamento dei tipi corso(" + error + ")"
          );
        });
    },
    dateValidation() {
      if (this.startDate) {
        if (this.startDateTemp > this.finishDateTemp) {
          this.dateStartRules = [
            "Data di inizio corso maggiore della data di fine corso"
          ];
          this.dateFinishRules = [
            "Data di fine corso minore della data di inizio corso"
          ];
        } else if (this.startDateTemp < this.currentDayTemp) {
          this.dateStartRules = [
            "Data di inizio corso minore della data odierna"
          ];
        } else {
          this.dateStartRules = [true];
        }
      }
      if (this.finishDate) {
        if (this.finishDateTemp < this.startDateTemp) {
          this.dateFinishRules = [
            "Data di fine corso minore della data di inizio corso"
          ];
        } else if (this.finishDateTemp < this.currentDayTemp) {
          this.dateFinishRules = [
            "Data di fine corso minore della data odierna"
          ];
        } else {
          this.dateFinishRules = [true];
        }
      }
    },
    timeValidation() {
      if (this.time_start) {
        if (this.time_start >= this.time_finish) {
          this.timeStartRule = [
            "Ora di inizio corso maggiore o uguale all'ora di fine corso"
          ];
          this.timeFinishRule = [
            "Ora di fine corso minore o uguale all'ora di inizio corso"
          ];
        } else {
          this.timeStartRule = [true];
        }
      }
      if (this.time_finish) {
        if (this.time_finish <= this.time_start) {
          this.timeFinishRule = [
            "Ora di fine corso minore o uguale all'ora di inizio corso"
          ];
        } else {
          this.timeFinishRule = [true];
        }
      }
    },
    startDateFilter() {
      const date = new Date(this.startDateTemp);
      this.startDate = date.toLocaleString(["it-IT"], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    finishDateFilter() {
      const date = new Date(this.finishDateTemp);
      this.finishDate = date.toLocaleString(["it-IT"], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    onCreate() {
      if (this.$refs.form.validate()) {
        if (this.note === undefined || this.note === null) {
          this.note = "";
        }
        this.loading = true;
        const course = {
          nome: this.course_name,
          posti_tot: this.course_places,
          posti_occupati: 0,
          data_inizio: this.startDateTemp,
          data_fine: this.finishDateTemp,
          ora_inizio: this.time_start,
          ora_fine: this.time_finish,
          note: this.note,
          descrizione_svolgimento: this.description,
          id_tipo_corso: this.tipoCorso
        };
        db.collection("corsi")
          .doc()
          .set(course)
          .then(() => {
            bus.$emit("successfullOperation", "Corso creato con successo");

            this.loading = false;
            this.dialog = false;
            bus.$emit("modified", !this.changed);
            this.$refs.form.reset();
          })
          .catch(error => {
            this.loading = false;
            bus.$emit(
              "errorOperation",
              "Errore: problema nella creazione del corso(" + error + ")"
            );
          });
      }
    },
    closeDialog() {
      this.dialog = false;
      this.loading = false;
      this.$refs.form.reset();
    }
  },
  created() {
    let currentDayTemp = new Date()
    this.currentDay = currentDayTemp.toLocaleString(["it-IT"], {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
    this.listener();
  }
};
</script>
